var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pageError" }, [
    _vm._v(" " + _vm._s(_vm.errorType) + " "),
    _c("div", { staticClass: "session-expired" }, [
      _c("img", { attrs: { src: require("@/assets/images/404.webp") } }),
      _c("h2", [_vm._v(_vm._s(_vm.$t("Oops")))]),
      _c("p", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.$t("Your session expired, please login again."))),
      ]),
      _vm.withCommission
        ? _c(
            "button",
            { staticClass: "go-to-login", on: { click: _vm.goToLoginPage } },
            [_vm._v(_vm._s(_vm.$t("Go to login page")))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }